import ApiMixin from './index'
const errHandle = () => {
  app.$store.dispatch('fullToken', null)
  app.$store.dispatch('loginTips', true)
  app.$store.dispatch('hasLogin', false)
  LocalForage.clear()
  localStorage.clear()
  document.location.href = '/#/login'
  // document.location.href = `${
  //   currentEnv.VUE_APP_EASC_PAGE
  // }/#/login?callbackUrl=${encodeURIComponent(window.location.href)}`
}
const callback = {
  async globalCB(err, res, extra = { errorMsg: true }) {
    if (err && !err.response && extra.errorMsg) {
      app.$message.warning(err.message)
    }
    if (err) {
      const errInfo = err.response
      // console.log('errInfo', errInfo)
      if (errInfo && errInfo.status) {
        if (_.includes([401, 403], errInfo.status)) {
          const refreshToken = await LocalForage.getItem('refreshToken')
          if (!refreshToken) {
            app.$message.warning('请先登录。')
            errHandle()
          }
          const refreshRes = await ApiMixin.methods.apiRefreshReq({
            refreshToken,
          })
          if (refreshRes && refreshRes.innerResponse) {
            const resData = refreshRes.innerResponse
            const fullToken = `${resData.token_type} ${resData.access_token}`
            LocalForage.setItem('fullToken', fullToken)
            LocalForage.setItem('accessToken', resData.access_token)
            LocalForage.setItem('refreshToken', resData.refresh_token)
            axios.defaults.headers.common.Authorization = fullToken
            app.$store.dispatch('fullToken', fullToken)
            app.$store.dispatch('hasLogin', true)
            const instance = axios.create({
              headers: {
                'Content-Type': errInfo.config.headers['Content-Type'],
              },
            })
            let againRes = null
            if (errInfo.config && errInfo.config.method === 'get') {
              const newRes = await axios.get(errInfo.config.url)
              if (newRes && newRes.data) {
                againRes = newRes.data
              } else {
                errHandle()
              }
            } else if (errInfo.config && errInfo.config.method === 'post') {
              const newRes = await instance.post(errInfo.config.url, errInfo.config.data)
              if (newRes && newRes.data) {
                againRes = newRes.data
              } else {
                errHandle()
              }
            } else if (errInfo.config && errInfo.config.method === 'patch') {
              const newRes = await instance.patch(errInfo.config.url, errInfo.config.data)
              if (newRes && newRes.data) {
                againRes = newRes.data
              } else {
                errHandle()
              }
            }
            // console.log('againRes', againRes)
            return againRes
          }
          return errHandle()
        }
        if (extra.errorMsg) {
          app.$message({
            message: `${errInfo.status} ${errInfo.statusText}` || '未知错误，请重试',
            success: false,
            type: 'error',
          })
        }
      }
      return {
        message: err.message || '发生了错误，请重试',
        success: false,
        error: err,
      }
    }
    const dataExist = !!(res && res.data)
    const failed = (_.isBoolean(res.data.success) && !res.data.success) || !!res.data.code
    const msgExist = !!(res.data.message || res.data.msg)
    if (dataExist && failed && msgExist && extra.errorMsg) {
      app.$message.warning(res.data.message || res.data.msg || '服务器返回了错误')
      return {
        message: res.data.message || res.data.msg || '服务器返回了错误',
        success: false,
        data: res.data,
      }
    }
    return res && res.data ? res.data : { message: '未知错误', success: false }
  },
  async globalCBForOld(err, res, extra = { errorMsg: true }) {
    if (err) {
      const errInfo = err.response
      if (errInfo && errInfo.status) {
        if (_.includes([401, 403], errInfo.status)) {
          const refreshToken = await LocalForage.getItem('refreshToken')
          if (!refreshToken) {
            // app.$store.dispatch('fullToken', null)
            // app.$store.dispatch('loginTips', true)
            // app.$store.dispatch('hasLogin', false)
            // LocalForage.setItem('fullToken', null)
            // app.$message({
            //   message: '请先登录',
            //   type: 'error',
            //   duration: 5 * 1000,
            // })
            // return err.response
            app.$message.warning('请先登录。')
            errHandle()
          }
          const refreshRes = await ApiMixin.methods.apiRefreshReq({
            refreshToken,
          })
          if (refreshRes && refreshRes.innerResponse) {
            const resData = refreshRes.innerResponse
            const fullToken = `${resData.token_type} ${resData.access_token}`
            LocalForage.setItem('fullToken', fullToken)
            LocalForage.setItem('accessToken', resData.access_token)
            LocalForage.setItem('refreshToken', resData.refresh_token)
            axios.defaults.headers.common.Authorization = fullToken
            app.$store.dispatch('fullToken', fullToken)
            app.$store.dispatch('hasLogin', true)
            let againRes = null
            const instance = axios.create({
              headers: {
                'Content-Type': errInfo.config.headers['Content-Type'],
              },
            })
            if (errInfo.config && errInfo.config.method === 'get') {
              const newRes = await instance.get(errInfo.config.url)
              if (newRes && newRes.data) {
                againRes = newRes
              } else {
                // app.$store.dispatch('fullToken', null)
                // app.$store.dispatch('loginTips', true)
                // app.$store.dispatch('hasLogin', false)
                errHandle()
              }
            } else if (errInfo.config && errInfo.config.method === 'post') {
              const newRes = await instance.post(errInfo.config.url, errInfo.config.data)
              if (newRes && newRes.data) {
                againRes = newRes
              } else {
                // app.$store.dispatch('fullToken', null)
                // app.$store.dispatch('loginTips', true)
                // app.$store.dispatch('hasLogin', false)
                errHandle()
              }
            } else if (errInfo.config && errInfo.config.method === 'patch') {
              const newRes = await instance.patch(errInfo.config.url, errInfo.config.data)
              if (newRes && newRes.data) {
                againRes = newRes
              } else {
                // app.$store.dispatch('fullToken', null)
                // app.$store.dispatch('loginTips', true)
                // app.$store.dispatch('hasLogin', false)
                errHandle()
              }
            }
            return againRes
          }
          // app.$store.dispatch('fullToken', null)
          // app.$store.dispatch('loginTips', true)
          // app.$store.dispatch('hasLogin', false)
          // return false
          return errHandle()
        }
        if (extra.errorMsg) {
          app.$message({
            message: errInfo.status
              ? `${errInfo.status} ${errInfo.statusText}`
              : '未知错误，请重试',
            success: false,
            type: 'error',
          })
        }
      }
      return {
        message: err.message || '发生了错误，请重试',
        success: false,
        error: err,
      }
    }
    const dataExist = !!(res && res.data)
    const failed = (_.isBoolean(res.data.success) && !res.data.success) || !!res.data.code
    const msgExist = !!(res.data.message || res.data.msg)
    if (dataExist && failed && msgExist && extra.errorMsg) {
      app.$message({
        message: res.data.message || res.data.msg,
        type: 'warning',
      })
      return {
        message: res.data.message || res.data.msg || '服务器返回了错误',
        success: false,
        data: res.data,
      }
    }
    return res
  },
}

export default callback
